/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/button-has-type */
import { IInputModel } from 'app/interfaces/input/input.interface';
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import InputComponent from '../InputComponent/InputComponent';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';
import './FilterBarComponent.scss';

const FilterBarComponent = function init(
		props: {
			formField: IInputModel[],
			loading:boolean,
			// eslint-disable-next-line react/require-default-props
			showFilterButton?: boolean,
			// eslint-disable-next-line no-unused-vars
			onSubmit: (payload: Record<string, string | number>) => void
		}
	):React.ReactElement {
	const { formField, onSubmit, loading, showFilterButton } = props;
	const filterForm = 'filterForm';
	const navigate = useNavigate();
	const location = useLocation();
	const [form, setForm] = useState(formField);
	const [startDate, setStartDate] = useState<string>('');
	const [endDate, setEndDate] = useState<string>('');
	// eslint-disable-next-line @typescript-eslint/no-use-before-define
	let formValue = initFormValue();

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onHandleSubmit = useCallback((event: ChangeEvent<any>): void => {
		event.preventDefault();
		form.forEach((field) => {
			if (field.formType === 'multi-select') {
				formValue = {
					...formValue,
					[field.name]: Array.from(event.target.elements[field.name]).map((item) => (item as HTMLInputElement).value).join(',')
					|| event.target.elements[field.name].value
				};
			} else {
				formValue = {
				...formValue,
				[field.name]: event.target.elements[field.name].value
				};
			}
		});
		formValue = {
			...formValue,
			page: '1'
		};
		onSubmit(formValue);
		navigate({
            search: `${createSearchParams(formValue)}`
        });
	}, []);

	const onReset = (): void => {
		navigate({
            search: ''
        });
		setStartDate('');
		setEndDate('');
		form.forEach((each) => {
			formValue = {
				...formValue,
				[each.name]: '',
				page: '1',
				startDate: '',
				endDate: '',
				value: ''
			};
		});

		navigate({
			search: `${createSearchParams(formValue)}`
		});
		onSubmit(formValue);
		setForm(form);
	};

	function useQuery(): URLSearchParams {
        const { search } = location;
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

	function initFormValue(): Record<string, string> {
		let temp = {};
		form.forEach((each) => {
			temp = {
				...temp,
				[each.name]: useQuery().get(each.name) || ''
			};
		});
		return temp;
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function onChangeHandle(event: any): void {
		const field = form.find((item) => item.name === event.name);
		let updatedStartDate;
		let updatedEndDate;
		if (event?.name === 'startDate' && event?.value[0] && event?.value[1]) {
			updatedStartDate = event?.value[0] ? event?.value[0] : '';
			updatedEndDate = event?.value[1] ? event?.value[1] : '';
			setStartDate(updatedStartDate);
			setEndDate(updatedEndDate);
		}

		formValue = {
			...formValue,
			page: '1',
			[event.name]: event.value,
			startDate: updatedStartDate ?? startDate,
			endDate: updatedEndDate ?? endDate,
		};

		const cleanFormValue = Object.fromEntries(
			Object.entries(formValue).filter(([_, value]) => value !== '' && value !== undefined && value !== null)
		);

		navigate({
			search: `${createSearchParams(cleanFormValue)}`
		});

		if ((event?.value[0] && event?.value[1] && field?.formType === 'datePicker') || field?.formType === 'select') {
			onSubmit(formValue);
		}
	}

	return (
		<div className="card">
			<form
				id={filterForm}
				className="filter-container"
				onSubmit={onHandleSubmit}
				onReset={onReset}
			>
				{
					form.map((each) => (
						<InputComponent
							key={each.id}
							id={each.id}
							formType={each.formType}
							placeholder={each.placeholder}
							name={each.name}
							apiErrorMessage={each.apiErrorMessage}
							loading={loading}
							options={each.options}
							value={String(useQuery().get(each.name) || '')}
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							onChange={(value: any) => onChangeHandle(value)}
						/>
					))
				}
				<div className="flex">
					{!loading && (
						<button
							type="reset"
							className="btn btn-reset"
						>
							Reset Filter
						</button>
					)}
					<button
						type="submit"
						className={`btn btn-reset ${!showFilterButton ? 'btn-hide' : ''}`}
					>
						Terapkan Filter
					</button>
				</div>
			</form>
		</div>
	);
};

export default FilterBarComponent;
